module.exports = __webpack_public_path__ + "static/join.f02ba2c3.png";